<ng-dialog-header title="Car Movement Inquiry"></ng-dialog-header>
<mat-dialog-content>
  <ns-grid
    [name]="gridConfigs.gridName"
    [gridTitle]="gridConfigs.gridTitle"
    [config]="gridConfigs.headerOptions"
    [data]="data"
    [columns]="gridConfigs.columns"
    [loading]="loading"
    [gridOptions]="gridConfigs.options"
    (refresh)="refresh.emit()"
  ></ns-grid>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>
